<script lang="ts">
	import DemoBanner from '$lib/demo/DemoBanner.svelte';
	import Header from '$lib/header/header.svelte';
	import IncidentPanel from '$lib/info/IncidentPanel.svelte';
	import LicenceGoingToEndPanel from '$lib/info/LicenceGoingToEndPanel.svelte';
	import MaintenancePanel from '$lib/info/MaintenancePanel.svelte';
	import VersionPanel from '$lib/info/VersionPanel.svelte';
	import QueueTaskHolder from '$lib/queuetasks/QueueTaskHolder.svelte';
	import {
		ConfirmDialog,
		ContextMenu,
		LoadingAnimation,
		Notificationholder
	} from '@enzianweb/shared';
	import * as Sentry from '@sentry/svelte';
	import Big from 'big.js';
	import type { Snippet } from 'svelte';
	import '@enzianweb/shared/extensions';
	import '@enzianweb/shared/styles.css';

	interface Props {
		children?: Snippet;
	}

	let { children }: Props = $props();

	// DON'T REMOVE, this sets the amount of decimal points for big.js for the whole app
	Big.DP = 6;

	if (import.meta.env.MODE == 'production' || import.meta.env.MODE === 'demo') {
		Sentry.init({
			dsn: 'https://44837a9fa9cc4dddbd3e6c4bea8d6886@o4505520938024960.ingest.sentry.io/4505520968499200',
			environment: import.meta.env.MODE
		});
	}

	localStorage.theme === 'dark'
		? document.documentElement.classList.add('dark')
		: document.documentElement.classList.remove('dark');
</script>

<div
	class="absolute top-0 bottom-0 left-0 right-0 grid grid-rows-[60px_auto_1fr] grid-cols-[1fr_minmax(auto,_1920px)_1fr] pattern-bg"
>
	<div class="col-span-3">
		<Header />
	</div>

	<!--Incident Banner-->
	<IncidentPanel />

	<MaintenancePanel />

	<!--Env indicator-->
	{#if import.meta.env.MODE !== 'production' && import.meta.env.MODE !== 'demo'}
		<p
			style="font-size: 35px; opacity: 0.1;"
			class="absolute top-20 left-6 text-2l font-bold text-red dark:text-white uppercase select-none pointer-events-none -z-20"
		>
			{import.meta.env.MODE}
		</p>
	{/if}

	<!--Demo Banner for signup-->
	{#if import.meta.env.MODE == 'demo'}
		<div class="absolute bottom-16 right-0" style="z-index: 99;">
			<DemoBanner />
		</div>
	{/if}

	<div class="col-start-2 row-start-3 overflow-y-auto">
		{@render children?.()}
	</div>

	<ConfirmDialog />

	<ContextMenu />

	<Notificationholder />

	<QueueTaskHolder />

	<LoadingAnimation />

	<!--Container for displaying a stack of info panels-->
	<div id="info-box" class="grid gap-4 absolute bottom-8 right-8">
		<!--Do not show version panel to demo users-->
		{#if import.meta.env.MODE != 'demo'}
			<LicenceGoingToEndPanel />

			<VersionPanel />
		{/if}
	</div>
</div>
